<div class="wrapper">
    <app-header></app-header>
    <div class="main">
        <div class="container-fluid container-fluid-5">
            <div class="row row5">
                <div class="sidebar col-md-2 hide-small">
                    <app-sidebar></app-sidebar>
                </div>
  
                <div class="col-md-10 report-main-content m-t-5">
                  <div class="coupon-card">
                    <div class="game-heading">
                      <span class="card-header-title">32 CARD CASINO </span>
                    </div>
                  </div>
                  <div>
                    <div class="m-b-30 div-figure" 
                    (click)="gotoexchangeGame('56967')">
                      <a>
                        <img src="assets/Casino/32cardsA.jpg" class="img-fluid">
                      </a>
                    </div>
                    <div class="m-b-30 div-figure" 
                    (click)="gotoexchangeGame('56966')">
                      <a>
                        <img src="assets/Casino/32cardsB.jpg" class="img-fluid">
                      </a>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
  </div>